import { styled } from "styled-components";
import { CircularProgress } from "@mui/material";

type LoadSpinnerPropsType = {
  color?: string;
  size?: number | string;
  className?: string;
};

export function LoadSpinner(props: LoadSpinnerPropsType) {
  const { color, size = 40, className } = props;

  return (
    <StyledSpinnerWrap className={className}>
      <CircularProgress sx={{ color }} size={size} />
    </StyledSpinnerWrap>
  );
}

const StyledSpinnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;